@use "~theme/typography";
@use "./tokens";

.button {
  @include typography.button;
  color: var(--white);
  background-color: var(--blue-02);
  border-color: var(--blue-02);
  height: tokens.$button-standard-height;
  width: 102px;
  border-radius: 4px;
  border: solid 2px transparent;
  outline: none;
  cursor: pointer;

  &:focus {
    box-shadow: 0 0 12px var(--highlight-blue);
  }
}

.buttonV2 {
  @include typography.button;
  color: var(--blue-02);
  background-color: var(--white);
  border-color: var(--blue-01);
  height: tokens.$button-standard-height;
  width: 102px;
  border: 1px solid var(--blue-02);
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  margin:5px;

  // &:focus {
  //   box-shadow: 0 0 12px var(--highlight-blue);
  // }
}

.small {
  width: 88px;
  padding: 0;
}

.button:hover {
  background-color: var(--blue-01);
  border-color: var(--blue-01);
}

.button:active {
  @include tokens.button-highlight;
}

.buttonV2:hover {
  background-color: var(--white);
  border-color: var(--blue-01);
}

// .buttonV2:active {
//   @include tokens.button-highlight;
// }


.selected {
  background: var(--blue-01);
  color: var(--white);
}

.buttonV2.selected:hover {
  background: var(--blue-01);
  color: var(--white);
}